<template>
<div class="animated fadeIn">
  <b-card no-body>
    <b-card-body>
      <b-row>
        <b-col lg="12">
          <!--<h6>Simple Form</h6>-->
          <b-form v-on:submit.prevent="onSubmit" v-on:reset.prevent="onReset" novalidate>

            <b-form-group label="Name" label-for="attributeName">
              <b-form-input id="name" type="text" aria-describedby="liveFeedbackName" :state="chkState('name')" v-model.lazy.trim="$v.form.name.$model" placeholder="Attribute Name" autofocus />
              <b-form-invalid-feedback id="liveFeedbackName">
                This is a required field.
              </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group label="Type" label-for="attributeType">
              <v-select :options="['BUILDING', 'FLOOR', 'ROOM', 'ACCOREQSTATUS', 'ACCOREQMSG']" v-model="$v.form.type.$model" placeholder="Select Attribute Type"></v-select>
            </b-form-group>

            <b-form-group label="Default Value" label-for="attributeDefaultValue">
              <b-form-textarea id="default_value" type="text" aria-describedby="attributeDefaultValue"  rows="4" max-rows="10" v-model.lazy.trim="$v.form.default_value.$model" placeholder="Attribute Address" />
            </b-form-group>

            <b-button type="submit" variant="primary" :disabled="$v.form.$invalid">
              Submit
            </b-button>
            <b-button class="ml-1" type="reset" @click="onCancel">Cancel</b-button>
          </b-form>
          <br />
        </b-col>
      </b-row>
    </b-card-body>
  </b-card>
</div>
</template>

<script>
import Vue from 'vue'
import {
  mapState,
  mapActions
} from 'vuex'
import {
  required
} from "vuelidate/lib/validators"

const formShape = {
  name: "",
  type: null,
  default_value: "",
  is_active: null
}

export default {
  name: "AttributeFormEdit",
  props: {
    attribute: Object
  },
  data() {
    return {
      form: Object.assign({}, formShape),
      submitted: false
    }
  },
  computed: {
    isValid() {
      return !this.$v.form.$anyError
    },
    isDirty() {
      return this.$v.form.$anyDirty
    },
    AttributeTypeList() {
      let list = []
      Vue._.forEach(this.$store.state.AttributeTypes.all, (AttributeType) => {
        list.push({
          label: AttributeType.Attributetypename,
          value: AttributeType.Attributetypeid
        })
      })
      return list
    },
  },
  validations: {
    form: {
      name: {
        required
      },
      type: {
        required
      },
      default_value: {},
      is_active: {
        required
      }
    }
  },
  methods: {
    onSubmit() {
      if (this.validate()) {
        this.$nextTick(() => {
          this.submitted = true
          let params = {
            id: this.attribute.id,
            name: this.$v.form.name.$model,
            type: this.$v.form.type.$model,
            default_value: this.$v.form.default_value.$model,
            is_active: this.$v.form.is_active.$model,
          }
          this.$store.dispatch('attributes/editAttribute', params)
            .then(() => {
              this.$emit('success')
              this.showSuccessMsg()
            })
            .catch((error) => {
              if (error.response.status == 422) {
                this.showErrorMsg({
                  message: error.response.data.message
                })
              } else {
                this.showErrorMsg()
              }
            })
        })
      }
    },
    onCancel() {
      this.$emit('cancel')
    },
    onReset() {
      // Reset validation
      this.form = formShape
      this.submitted = false
      this.$nextTick(() => {
        this.$v.$reset()
      })
    },
    chkState(val) {
      const field = this.$v.form[val]
      return field.$dirty ? !field.$invalid : null
    },
    findFirstError(component = this) {
      if (component.state === false) {
        if (component.$refs.input) {
          component.$refs.input.focus()
          return true
        }
        if (component.$refs.check) {
          component.$refs.check.focus()
          return true
        }
      }
      let focused = false
      component.$children.some((child) => {
        focused = this.findFirstError(child)
        return focused
      })

      return focused
    },
    validate() {
      this.$v.$touch()
      this.$nextTick(() => this.findFirstError())
      return this.isValid
    }
  },
  beforeMount() {
    this.form.name = this.attribute.name
    this.form.type = this.attribute.type
    this.form.default_value = this.attribute.default_value
    this.form.is_active = this.attribute.is_active.toString()
  }
}
</script>
